// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__p01cD","image":"styles_image__-wBxH","textContainer":"styles_textContainer__Qcy3M","loadingContainer":"styles_loadingContainer__btFbM"};